import { render } from "./ModalAssociaNotaSpesa.vue?vue&type=template&id=10bc17aa&scoped=true"
import script from "./ModalAssociaNotaSpesa.vue?vue&type=script&lang=js"
export * from "./ModalAssociaNotaSpesa.vue?vue&type=script&lang=js"

import "./ModalAssociaNotaSpesa.vue?vue&type=style&index=0&id=10bc17aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bc17aa"]])

export default __exports__